import React, { useState } from 'react'
import PopUpLayer from './PopUpLayer'
import StaticData from './StaticData'
import CouponsForm from './CouponsForm'
import {
  ContinueShoppingText,
  CouponsContinueShoppingContainer,
  CouponsFooterContainer,
  CouponsInnerContainer,
  CouponsMainContainer, CouponsPrivacyContainer, CouponsTextPointer,
} from './style/Coupons.css'
import useWmoEnabled from '@usap/carparts/src/shared/hooks/useWmoEnabled'
import CouponsWMO from './CouponsWMO'

export default function Coupons({
  onSubscribe,
  message,
  setMessage,
  Link,
  getPrivacyPolicy,
  couponsData,
}) {
  const [privacyPolicy, setPrivacyPolicy] = useState('')

  const [policy, setPolicy] = useState(false)

  const date = new Date()

  const currentYear = date.getFullYear()

  const currentMonth = date.getMonth()

  const month = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ]

  const infoMessage = couponsData.text.replace(
    '_Month_Year_',
    `${month[parseInt(currentMonth, 10)]} ${currentYear}`,
  )

  const readPrivacyPolicy = () => {
    if (!privacyPolicy) {
      getPrivacyPolicy()
        .then(({ data }) => {
          if (
            data &&
            data.data &&
            data.data.contents &&
            data.data.contents.text
          ) {
            const contents = data.data.contents.text
            setPrivacyPolicy(contents)
          }
        })
        .catch(err => {
          throw err
        })
    }
    setPolicy(true)
  }

  const isWmoEnabled = useWmoEnabled()

  if (isWmoEnabled) {
    return (
      <CouponsWMO
        onSubscribe={onSubscribe}
        setMessage={setMessage}
        Link={Link}
        couponsData={couponsData}
      />
    )
  }

  return (
    <>
      <PopUpLayer
        flag={policy}
        records={privacyPolicy}
        closePopUp={setPolicy}
        PopUpComponent={StaticData}
      />

      <CouponsMainContainer
        bgImage={couponsData.bgimg}
        width="100%"
        align="center"
      >
        <CouponsInnerContainer
          align="center"
          width="600px"
          round="small"
        >
          <CouponsForm
            onSubscribe={onSubscribe}
            message={message}
            setMessage={setMessage}
            carpartsLogo={couponsData.logo}
            infoMessage={infoMessage}
          />
          <CouponsFooterContainer
            width="100%"
            align="center"
          >
            <CouponsPrivacyContainer width="50%">
              <CouponsTextPointer
                size="16px"
                color="blueLink"
                onClick={readPrivacyPolicy}
              >
                Privacy Policy
              </CouponsTextPointer>
            </CouponsPrivacyContainer>

            <CouponsContinueShoppingContainer width="50%">
              <Link to="/">
                <ContinueShoppingText
                  size="16px"
                  color="blueLink"
                >
                  Continue Shopping
                </ContinueShoppingText>
              </Link>
            </CouponsContinueShoppingContainer>
          </CouponsFooterContainer>
        </CouponsInnerContainer>
      </CouponsMainContainer>
    </>
  )
}
